module.exports = __webpack_public_path__ + "static/hexowatch-logo-white-8b3045e8170a195dbb582ebda794d2f9.svg";